module.exports = __webpack_public_path__ + "img/code.4995675d.svg";